import { Button, Modal, Text } from "@mantine/core";
import { useState } from "react";

import { useUploadFileApi } from "../../../../../hooks";
import { Flex } from "../../../../../styled";
import { Notification } from "../../../../../utils/Notification";
import FilesModal from "../../../../shared/_Modals/FilesModal/FilesModal";
import ClearSelectionsButton from "../EntriesSelectList/ClearSelectionsButton";
import EntriesSelectList from "../EntriesSelectList/EntriesSelectList";
import {
  type IEntrySelectValue,
  type MultipleModalProps,
} from "../Multiple.model";

const MultipleAttachmentModal = ({
  open,
  close,
  reviews,
  refetch,
}: MultipleModalProps) => {
  const [selectedEntries, setSelectedEntries] = useState<IEntrySelectValue[]>(
    [],
  );
  const [files, setFiles] = useState<File[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  const { upload } = useUploadFileApi();

  // const handleUpload = async (files: File[]) => {
  //   const body: Record<string, string> = { aid: aid ?? "" };
  //   await upload("upload-report", files, body, async () => {
  //     Notification("Success", `The files has been added successfully`, "green");
  //     await fetchFiles();
  //   });
  // };
  const handleClose = () => {
    setFiles([]);
    setSelectedEntries([]);
    close();
  };
  const handleSave = async () => {
    setIsUploading(true);
    const uploadPromises = selectedEntries.map(async entry => {
      const body: Record<string, string> = {};
      body[String(entry.idType)] = entry.id;
      return await upload("upload-file", files, body);
    });

    try {
      await Promise.all(uploadPromises);
      // Handle success notification or further actions here
      Notification("Success", "Attachments added to selected entries", "green");
      refetch();
      handleClose();
    } catch (error) {
      console.error("Error during uploads:", error);
      Notification("Error", "There was an error while uploading files", "red");
      // Handle error notification or further actions here
    } finally {
      setIsUploading(false);
    }
  };
  const handleAddFile = (fs: File[]) => {
    if (files.length + fs.length > 10) {
      Notification(
        "Error",
        "You can only upload up to 10 files at once",
        "red",
      );
      return;
    }
    setFiles(prev => [...prev, ...fs]);
  };
  const handleRemoveFile = (filename: string) =>
    setFiles(prev => prev.filter(f => f.name !== filename));

  return (
    <Modal
      title="Upload attachment to multiple entries"
      opened={open}
      onClose={handleClose}
      withCloseButton={false}
      size="1200px"
      styles={{ body: { maxHeight: "80vh", overflow: "hidden" } }}>
      <FilesModal
        _files={files}
        handleUpload={handleAddFile}
        renderOnlyContent
        isMultipleAttachmentsModal
        overrideHandleRemove={handleRemoveFile}
        title={<Text size="xl">Select files to upload</Text>}
        gallery={false}
      />

      <Flex justify="space-between" align="center" mt={15} h={50}>
        <Text size="xl">Select entries to assign files to</Text>
        <ClearSelectionsButton
          items={[]}
          itemsLength={selectedEntries.length}
          setItems={setSelectedEntries}
        />
      </Flex>
      <EntriesSelectList
        loading={false}
        items={reviews?.filter(r => !r.weid) ?? []}
        selectedEntries={selectedEntries}
        setSelectedEntries={setSelectedEntries}
      />

      <Flex justify="end" mt={15}>
        <Button
          variant="outline"
          onClick={handleSave}
          disabled={
            selectedEntries.length === 0 ||
            files.length === 0 ||
            selectedEntries.length > 15
          }
          loading={isUploading}>
          Save
        </Button>
      </Flex>
    </Modal>
  );
};
export default MultipleAttachmentModal;
